// extracted by mini-css-extract-plugin
export default {"alert":"KeywordsData__alert___u6ymc"};